export default {
  GET_LIST: '/manage/filterKeyword/findList',
  SAVE: '/manage/filterKeyword/save',
  GET_DETAIL: '/manage/filterKeyword/find',
  UPDATE: '/manage/filterKeyword/update',
  EXPORT: '/manage/filterKeyword/export',
  CHANGE_STATUS: '/manage/filterKeyword/enableOperate',
  DELETE: '/manage/filterKeyword/delete',
  UPLOAD: '/manage/filterKeyword/upload',
  DOWNLOAD: '/auth/public/download_file'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/commentKeywords.js